<div class="p-4 rounded flex justify-between items-start {{ color }}">
  <div class="flex flex-column justify-between items-center">
    @if (icon !== "") {
      <mat-icon
        class="message-icon mr-2 flex self-start"
        [svgIcon]="icon" />
    }

    <div class="flex flex-col items-start">
      @if (title !== "") {
        <div
          class="text-base font-bold mb-2"
          [innerHTML]="title | translate"></div>
      }
      @if (message !== "") {
        <div
          class="font-normal"
          [innerHTML]="message | translate: messageParams"></div>
      }

      @if (messageList.length > 0) {
        @for (item of messageList; track $index) {
          <div
            class="font-normal"
            [innerHTML]="item | translate"></div>
        }
      }
    </div>
  </div>

  @if (canClose) {
    <mat-icon
      class="close-icon hover:cursor-pointer text-{{ textColor[color] }}"
      svgIcon="remix:System/close-line"
      (click)="closed.emit()" />
  }
</div>
